import { all } from 'redux-saga/effects';
import postalOperatorsWatcher from './PostalOperatorsSaga';

function* postalOperatorsUnlocodeSaga() {
  yield all([
    postalOperatorsWatcher(),
  ]);
}

export default postalOperatorsUnlocodeSaga;
